// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"196":"azure","806":"date-input-polyfill","997":"clipboard"}[chunkId] + "." + {"196":"7dc87228957cca4284e9","806":"4106373f421909f9aec3","997":"299bae06e963a76751dd"}[chunkId] + ".js";
};